import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ContactsSelectedIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "17.277"}
      viewBox="0 0 20 17.277"
    >
      <g
        id="Selection_Icon"
        data-name="Selection Icon"
        transform="translate(378.001 284)"
      >
        <path
          id="União_24"
          data-name="União 24"
          d="M12.642,16.964l-2.225-2.248a1.065,1.065,0,0,1,0-1.494l.01-.011a1.059,1.059,0,0,1,1.506,0l1.473,1.473L18.166,9.89a1.072,1.072,0,0,1,1.517,0l.011.011a1.066,1.066,0,0,1,0,1.5l-5.524,5.568a1.087,1.087,0,0,1-1.527,0ZM0,17.2V15.051c0-2.862,5.73-4.3,8.6-4.3a10.048,10.048,0,0,1,1.074.064l-.9.881a3.224,3.224,0,0,0-.022,4.582l.925.923ZM4.3,4.3A4.3,4.3,0,1,1,8.6,8.6,4.3,4.3,0,0,1,4.3,4.3Z"
          transform="translate(-378.001 -284)"
          fill={color || "#fff"}
        />
      </g>
    </svg>
  );
}
